import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

// TODO: Full empty-state design is in a separate ticket.
// This is a placeholder component.
export function NoSuggestionsFound() {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.container}>
			<Text color="color.text.subtlest">{formatMessage(i18n.noSuggestionsFound)}</Text>
		</Box>
	);
}

const i18n = defineMessages({
	noSuggestionsFound: {
		id: 'space-suggestions.no-suggestions-found',
		defaultMessage: 'No suggestions found',
		description:
			'Placeholder text shown when there are no suggestions or activity items to display',
	},
});

const styles = cssMap({
	container: {
		paddingBlockStart: token('space.300'),
		paddingBlockEnd: token('space.300'),
		paddingInlineStart: token('space.300'),
		paddingInlineEnd: token('space.300'),
		textAlign: 'center',
	},
});
